module.exports = __webpack_public_path__ + "static/gold_dragon_fly-01d0d24e06658c44c6b665545ec39f82.png";